import React from "react";
import "./Login.css";
import { Container, Button ,Form, Alert} from 'react-bootstrap';
import useBackend, { SpinnerX } from '../../services/useBackend_v2';
import {Sida,Rubrik,Stycke,ContentWrapper,Artickel} from "../ContentStyles";
import {Branding} from '../../services/misc';

export default function RequestPassword() { 
  const { loading, data, Refresh, resultVariant, resultVisible, resultText, Update } = useBackend('');

  async function handleSubmit(e) {
    e.preventDefault();
    const formData = new FormData(e.target),formDataObj = Object.fromEntries(formData.entries());
    await Update({ SystemID: "NS", PasswordReset: formDataObj }, 'POST', 3000, '/backend/auth/password/request/new');
  }
    
  return (
    <ContentWrapper>
      <Container>
        <Sida>
          <Artickel>
          <Rubrik>Begär nytt lösenord</Rubrik>
          <Stycke>
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label className="FormHeaderText">Email</Form.Label>
                  <Form.Control autoFocus type="email" name="username" />
                </Form.Group>  

                <Form.Group className="mb-3"  hidden={!loading}>
                    <SpinnerX  />
                </Form.Group>                                      
                    
                <Form.Group className="mb-3"  hidden={!resultVisible}>
                    <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert> 
                </Form.Group>        

                <Form.Group className="mb-3">
                    <Button className="QmeButton" style={{backgroundColor:Branding().ButtonColor}} variant="primary" type="submit">Skicka</Button>
                </Form.Group>   
            </Form> 
            </Stycke>
          </Artickel>
        </Sida>
      </Container>
    </ContentWrapper>
  );
};